export const mockExpenses = [
  {
    id: '1',
    title: 'Mağaza Kirası',
    category: 'Kira',
    amount: 12000,
    date: '2026-06-01',
    payment_status: 'Ödendi',
    due_date: '2026-06-01',
    description: 'Haziran ayı kira ödemesi',
    created_at: '2026-06-01T09:00:00Z',
  },
  {
    id: '2',
    title: 'Elektrik Faturası',
    category: 'Elektrik',
    amount: 850,
    date: '2026-05-28',
    payment_status: 'Ödendi',
    due_date: '2026-06-05',
    description: 'Mayıs ayı elektrik faturası',
    created_at: '2026-05-28T10:00:00Z',
  },
  {
    id: '3',
    title: 'Doğalgaz Faturası',
    category: 'Doğalgaz',
    amount: 420,
    date: '2026-05-25',
    payment_status: 'Ödendi',
    due_date: '2026-06-02',
    description: 'Mayıs ayı doğalgaz faturası',
    created_at: '2026-05-25T11:00:00Z',
  },
  {
    id: '4',
    title: 'Personel Maaşları',
    category: 'Personel',
    amount: 18000,
    date: '2026-06-01',
    payment_status: 'Ödendi',
    due_date: '2026-06-05',
    description: 'Haziran ayı personel maaşları',
    created_at: '2026-06-01T14:00:00Z',
  },
  {
    id: '5',
    title: 'Su Faturası',
    category: 'Su',
    amount: 180,
    date: '2026-05-20',
    payment_status: 'Ödendi',
    due_date: '2026-05-30',
    description: 'Mayıs ayı su faturası',
    created_at: '2026-05-20T09:00:00Z',
  },
  {
    id: '6',
    title: 'Instagram Reklam',
    category: 'Reklam',
    amount: 2500,
    date: '2026-05-15',
    payment_status: 'Ödendi',
    due_date: '2026-05-20',
    description: 'Yaz koleksiyonu reklam kampanyası',
    created_at: '2026-05-15T13:00:00Z',
  },
  {
    id: '7',
    title: 'Kargo Gönderileri',
    category: 'Kargo',
    amount: 1200,
    date: '2026-05-10',
    payment_status: 'Ödendi',
    due_date: '2026-05-15',
    description: 'Mayıs ayı kargo ücretleri',
    created_at: '2026-05-10T10:00:00Z',
  },
  {
    id: '8',
    title: 'Muhasebe Hizmeti',
    category: 'Muhasebe',
    amount: 1500,
    date: '2026-05-05',
    payment_status: 'Ödendi',
    due_date: '2026-05-10',
    description: 'Mayıs ayı muhasebe hizmet bedeli',
    created_at: '2026-05-05T11:00:00Z',
  },
  {
    id: '9',
    title: 'Aidat',
    category: 'Aidat',
    amount: 350,
    date: '2026-06-01',
    payment_status: 'Ödendi',
    due_date: '2026-06-05',
    description: 'Haziran ayı site aidatı',
    created_at: '2026-06-01T08:00:00Z',
  },
  {
    id: '10',
    title: 'KDV Ödemesi',
    category: 'Vergi',
    amount: 3200,
    date: '2026-05-01',
    payment_status: 'Ödendi',
    due_date: '2026-05-15',
    description: 'Mayıs ayı KDV ödemesi',
    created_at: '2026-05-01T09:00:00Z',
  },
  {
    id: '11',
    title: 'Mağaza Dekorasyonu',
    category: 'Diğer',
    amount: 4500,
    date: '2026-05-18',
    payment_status: 'Ödenecek',
    due_date: '2026-06-18',
    description: 'Yaz vitrin düzenlemesi',
    created_at: '2026-05-18T15:00:00Z',
  },
  {
    id: '12',
    title: 'Etiket ve Ambalaj',
    category: 'Diğer',
    amount: 800,
    date: '2026-05-22',
    payment_status: 'Ödenecek',
    due_date: '2026-06-10',
    description: 'Yeni ürün etiketleri ve ambalaj malzemesi',
    created_at: '2026-05-22T10:00:00Z',
  },
];